import { RxStompConfig } from "@stomp/rx-stomp";
import { WebSocketService } from "./web-socket.service";
import { environment } from "@env";

const WS_ENDPOINT = `${environment.apiUrl.replace(
  /https?/,
  "wss"
)}invoice-processing`;

export const rxStompConfig: RxStompConfig = {
  brokerURL: WS_ENDPOINT,
  // How often to heartbeat?
  // Interval in milliseconds, set to 0 to disable
  heartbeatIncoming: 0, // Typical value 0 - disabled
  heartbeatOutgoing: 20000, // Typical value 20000 - every 20 seconds

  // Wait in milliseconds before attempting auto reconnect
  // Set to 0 to disable
  // Typical value 500 (500 milli seconds)
  reconnectDelay: 1000

  // Will log diagnostics on console
  // It can be quite verbose, not recommended in production
  // Skip this key to stop logging to console
  // debug: (msg: string): void => {
  //   console.log(new Date(), msg);
  // }
};

export function rxStompServiceFactory() {
  const rxStomp = new WebSocketService();
  rxStomp.configure(rxStompConfig);
  rxStomp.activate();
  return rxStomp;
}
